<template>
  <section class="section-7 wrapper">
    <div class="hd">
      <h2 class="title wow bounceInUp">
        真实学员案例
      </h2>
    </div>

    <div class="content">
      <p>TTPS适合什么样的交易员？在经过多期实战教学打磨后，TTPS教练团能够快速定位学员疑点难点，辅以一对一面授指导。真正做到任何交易员都可学习，可复制，杜绝盲目亏损，实现资金曲线平滑增长。</p>
    </div>

    <div class="students">
      <div class="students-hd">
        <div
          ref="inner"
          class="students-hd-inner"
          :style="hdStyles"
        >
          <div
            v-for="(item, i) in students"
            :key="item.name"
            class="students-item"
            :class="{
              active: current === i
            }"
            @click="onTabClick(i)"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>

      <div class="students-bd">
        <div class="students-content">
          <div>
            <span>Before:</span> {{ students[current] ? students[current].content1 : '' }}
          </div>
          <div>
            <span>After:</span> {{ students[current] ? students[current].content2 : '' }}
          </div>

          <div class="tip">
            # TTPS线下训练账户 （500美元起步/4天资金曲线）#
          </div>
        </div>
        <div class="students-pic">
          <h5>资金曲线</h5>
          <span
            class="btn-prev"
            @click="onPrev"
          />
          <span
            class="btn-next"
            @click="onNext"
          />
          <vue-slick-carousel
            v-if="students.length > 0"
            ref="carousel"
            v-bind="slickSettings"
            @afterChange="onTabClick"
          >
            <div
              v-for="item in students"
              :key="item.name"
            >
              {{ item.key }}
              <div
                class="pic pic-1"
                :class="'pic-top-' + item.key"
              />
              <div
                class="pic pic-2"
                :class="'pic-bottom-' + item.key"
              />
            </div>
          </vue-slick-carousel>
        </div>
      </div>
    </div>

    <btn-contact name="B页-真实学员案例-预约咨询" />
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import { getStudents } from '@/api';
import BtnContact from './BtnContact.vue';

export default {
  components: {
    BtnContact,
    VueSlickCarousel,
  },
  data() {
    return {
      middle: 0,
      current: 2,
      students: [],
      slickSettings: {
        infinite: true,
        arrows: false,
        edgeFriction: 0.35,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
      },
    };
  },
  computed: {
    hdStyles() {
      let count = 0;
      if (this.current >= this.students.length - this.middle - 1) {
        count = this.students.length - this.visualCount;
      } else if (this.current <= this.middle) {
        count = 0;
      } else {
        count = this.current - this.middle;
      }

      return {
        transform: `translate(-${count * (1 / this.visualCount) * 100}%, 0)`,
      };
    },
  },
  mounted() {
    getStudents().then((res) => {
      this.students = res;

      this.$nextTick(() => {
        const innerWidth = this.$refs.inner.offsetWidth;
        const itemWidth = document.querySelector('.students-item').offsetWidth;
        this.visualCount = Math.round(innerWidth / itemWidth);
        this.middle = (this.visualCount - 1) / 2;

        this.goTo(this.current);
      });
    });
  },
  methods: {
    onTabClick(i) {
      this.onCurrentChange(i);
      this.goTo(i);
    },
    onCurrentChange(i) {
      this.current = i < 0 ? this.students.length - 1 : i > this.students.length - 1 ? 0 : i;
    },
    onNext() {
      this.onCurrentChange(this.current + 1);
      this.$refs.carousel.next();
    },
    onPrev() {
      this.onCurrentChange(this.current - 1);
      this.$refs.carousel.prev();
    },
    goTo(i) {
      this.$refs.carousel.goTo(i);
    },
  },
};
</script>

<style lang="scss" scoped>
.section-7 {
  padding-top: percentage(120px / $deviceWidth);
  padding-bottom: percentage(80px / $deviceWidth);
  overflow: hidden;

  .title {
    width: percentage(499px / $deviceWidth);
    padding-top: percentage(140px / $deviceWidth);
  }

  .content {
    width: percentage(1440px / $deviceWidth);
    margin: percentage(90px / $deviceWidth) auto 0;
    font-size: 20px;
    line-height: 42px;
    font-weight: 600;
    text-align: left;
    color: #3A4047;
    opacity: .8;
  }

  .students {
    position: relative;
    margin: percentage(130px / $deviceWidth) auto 0;

    &-hd {
      width: percentage(1680px / $deviceWidth);
      margin: 0 auto;
      white-space: nowrap;
      overflow: hidden;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 14px;
        height: 3px;
        background-color: #dee3e5;
      }

      &-inner {
        position: relative;
        z-index: 2;
        padding: 17px 0 10px;
        transition: transform .3s;
        white-space: nowrap;
      }
    }

    &-item {
      position: relative;
      width: 20%;
      display: inline-block;
      padding-top: 30px;
      margin-top: -2px;
      font-size: 24px;
      color: #3A4047;
      line-height: 24px;
      font-family: SourceHanSansCN;
      cursor: pointer;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        width: 12px;
        height: 12px;
        transform: translate(-50%, -50%);
        background-color: #9ea6ae;
        border-radius: 100%;
        transition: all .2s;
      }

      span {
        display: block;
        font-size: 32px;
        transform: scale(.75);
        transition: all .3s ease-out;
        will-change: transform;
        white-space: nowrap;
      }

      &.active {
        color: #2E76E1;
        font-weight: 600;
        white-space: nowrap;

        span {
          display: block;
          transform: scale(1);
        }

        &::before {
          width: 30px;
          height: 30px;
          background: url("~assets/circle.png") center/contain no-repeat;
        }
      }
    }

    &-content {
      margin: percentage(60px / $deviceWidth) auto 0;
      width: percentage(1440px / $deviceWidth);
      font-size: 20px;
      color: #3A4047;
      opacity: .8;
      line-height: 40px;
      span {
        font-family: SourceHanSerifCN;
        font-weight: 600;
        color: #2E76E1;
      }
      .tip {
        font-size: 20px;
        margin-top: percentage(56px / 1440px);
        color: #2E76E1;
        font-weight: 600;
      }
    }

    &-pic {
      position: relative;
      width: percentage(1440px / $deviceWidth);
      margin: percentage(60px / $deviceWidth) auto 0;

      h5 {
        position: absolute;
        top: 0;
        left: 0;
        transform: translate(-100%, 0);
        margin-left: percentage(-30px / $deviceWidth);
        width: percentage(131px / $deviceWidth);
        padding-top: percentage(43px / $deviceWidth);
        background: url("~assets/zijin.png") center/contain no-repeat;
        @include hdpi() {
          background-image: url("~assets/zijin@2x.png");
        }
      }

      img {
        width: 100%;
      }

      .pic {
        width: 100%;
        &-1 {
          padding-top: percentage(576px / 1440px);
        }
        &-2 {
          margin-top: percentage(-110px / 1440px);
          padding-top: percentage(780px / 1440px);
        }
      }

      @for $i from 0 through 7 {
        .pic-top-#{$i} {
          background: url("https://cdn.jin10.com/activity/ttps/students/#{$i}-1@2x.png") center top/100% auto no-repeat;
        }
        .pic-bottom-#{$i} {
          background: url("https://cdn.jin10.com/activity/ttps/students/#{$i}-2@2x.png") center top/100% auto no-repeat;
        }
      }
    }

    .btn-prev, .btn-next {
      position: absolute;
      top: 50%;
      z-index: 3;
      width: percentage(64px / $contentWidth);
      padding-top: percentage(64px / $contentWidth);
      cursor: pointer;
      background: url("~assets/btn-arrow.png") center/contain no-repeat;
      @include hdpi() {
        background-image: url("~assets/btn-arrow@2x.png");
      }

      &:hover {
        background: url("~assets/btn-arrow-active.png") center/contain no-repeat;
        @include hdpi() {
          background-image: url("~assets/btn-arrow-active@2x.png");
        }
      }
    }

    .btn-prev {
      left: percentage(-120px / $contentWidth);
      transform: translate(0, -50%);
    }

    .btn-next {
      right: percentage(-120px / $contentWidth);
      transform: translate(0, -50%) rotate(180deg);
    }
  }

  @include mediaWidth(1440px) {
    .content {
      font-size: 16px;
      line-height: 32px;
      .tip {
        font-size: 16px;
      }
    }
    .students {
      &-item {
        span {
          font-size: 24px;
        }

        &.active {
          font-size: 18px;
        }
      }

      &-content {
        font-size: 16px;
        line-height: 28px;
      }

      &-pic {
        h5 {
          width: 86px;
          height: 28px;
          padding-top: 0;
        }
      }
    }
  }

  @include mediaWidth(1024px) {
    .content {
      width: 85%;
    }

    .students {
      &-content {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  @include mediaWidth(#{$mbWidth}) {
    padding-top: percentage(78px / $mbWidth);

    .title {
      width: percentage(309px / $mbWidth);
      padding-top: percentage(86px / $mbWidth);
    }
    .content {
      width: percentage(680px / $mbWidth);
      font-size: 16px;
      line-height: 24px;
    }
    .students {
      margin: percentage(88px / $mbWidth) auto 0;
      &-hd {
        width: percentage(680px / $mbWidth);
      }
      &-item {
        padding-top: 24px;
        width: 33.33333333%;
        span {
          font-size: 16px;
          transform: scale(.85);
        }
        &::before {
          width: 9px;
          height: 9px;
        }
        &.active {
          &::before {
            width: 20px;
            height: 20px;
          }
        }
      }
      &-content {
        width: percentage(700px / $mbWidth);
        font-size: 12px;

        .tip {
          margin-top: 24px;
          font-size: 12px;
        }
      }
      &-pic {
        width: 100%;
        margin: percentage(50px / $mbWidth) auto percentage(60px / $mbWidth);

        h5 {
          display: none;
        }
        .pic {
          width: percentage(680px / $mbWidth);
          margin: 0 auto;

          &-1 {
            padding-top: percentage(247px / $mbWidth);
          }
          &-2 {
            margin-top: percentage(35px / $mbWidth);
            padding-top: percentage(736px / $mbWidth);
          }
        }

        @for $i from 0 through 7 {
          .pic-top-#{$i} {
            background: url("https://cdn.jin10.com/activity/ttps/students/m/#{$i}-1@2x.png") center/contain no-repeat;
          }
          .pic-bottom-#{$i} {
            background: url("https://cdn.jin10.com/activity/ttps/students/m/#{$i}-2@2x.png") center/contain no-repeat;
          }
        }
      }
      .btn-prev, .btn-next {
        top: 0;
        margin-top: percentage(260px / $mbWidth);
        width: percentage(53px / $mbWidth);
        padding-top: percentage(53px / $mbWidth);
      }
      .btn-next {
        right: percentage(28px / $mbWidth);
      }
      .btn-prev {
        left: percentage(28px / $mbWidth);
      }
    }
    .btn-next, .btn-prev {
      &:hover {
        background: url("~assets/btn-arrow.png") center/contain no-repeat !important;
        @include hdpi() {
          background-image: url("~assets/btn-arrow@2x.png") !important;
        }
      }
      &:active {
        background: url("~assets/btn-arrow-active.png") center/contain no-repeat !important;
        @include hdpi() {
          background-image: url("~assets/btn-arrow-active@2x.png") !important;
        }
      }
    }
  }

  @include mediaWidth(528px) {
    .students {
      &-hd {
        width: percentage(740px / $mbWidth);
      }
    }
    .content {
      font-size: 12px;

      .tip {
        font-size: 12px;
      }
    }
  }
}
</style>
